module.exports = __webpack_public_path__ + "img/category_27.b94291b5.png";